import { RefObject } from 'react'
import { ValidMoreAboutProps } from './types'

export type ScrollToItemType = ({
  itemsContainerRef,
  prevOrNext,
  setPrevArrowVisible,
  setNextArrowVisible,
}: {
  itemsContainerRef: RefObject<HTMLDivElement>
  prevOrNext: 'prev' | 'next'
  setPrevArrowVisible: (isVisible: boolean) => void
  setNextArrowVisible: (isVisible: boolean) => void
}) => () => void

const isValidMoreAboutProps = (props: any): props is ValidMoreAboutProps =>
  props?.items?.length > 0

const findCurrentIndex =
  (prevOrNext: 'prev' | 'next', scrollLeftAmount: number) =>
  (childOffset: number, index: number, array: number[]): boolean => {
    if (scrollLeftAmount === childOffset) {
      return true
    } else if (prevOrNext === 'next' && index === array.length - 1) {
      return true
    } else if (prevOrNext === 'prev') {
      const currentIndexArray = [...array].reverse()

      const currentIndex =
        array.length -
        (currentIndexArray.findIndex((offset) => offset < scrollLeftAmount) -
          1) -
        1

      if (currentIndex === index) {
        return true
      } else {
        return false
      }
    }

    return false
  }

const scrollToItem: ScrollToItemType =
  ({
    itemsContainerRef,
    prevOrNext,
    setPrevArrowVisible,
    setNextArrowVisible,
  }) =>
  () => {
    if (!itemsContainerRef.current) {
      return
    }

    let scrollLeftAmount = itemsContainerRef.current?.scrollLeft ?? 0

    const childElementOffsets = Array.from(
      itemsContainerRef.current?.children ?? []
    ).map((child, _index, array) =>
      child
        ? (child as HTMLElement).offsetLeft -
          (array[0] as HTMLElement).offsetLeft
        : -1
    )

    const currentIndex = childElementOffsets.findIndex(
      findCurrentIndex(prevOrNext, scrollLeftAmount)
    )

    let nextIndex = 0

    if (prevOrNext === 'next') {
      if (![-1, childElementOffsets.length - 1].includes(currentIndex)) {
        nextIndex = currentIndex + 1
      } else {
        nextIndex = childElementOffsets.length - 1
      }
    }

    if (prevOrNext === 'prev') {
      if (![-1, 0].includes(currentIndex)) {
        nextIndex = currentIndex - 1
      } else {
        nextIndex = 0
      }
    }

    itemsContainerRef.current.scrollLeft = childElementOffsets[nextIndex]

    setTimeout(() => {
      if (itemsContainerRef.current) {
        scrollLeftAmount = itemsContainerRef.current?.scrollLeft ?? 0

        if (
          itemsContainerRef.current?.scrollWidth -
            itemsContainerRef.current?.offsetWidth ===
          itemsContainerRef.current?.scrollLeft
        ) {
          setPrevArrowVisible(true)
          setNextArrowVisible(false)
        } else if (nextIndex === 0) {
          setPrevArrowVisible(false)
          setNextArrowVisible(true)
        } else {
          setPrevArrowVisible(true)
          setNextArrowVisible(true)
        }
      }
    }, 300)
  }

export { isValidMoreAboutProps, scrollToItem }
